<iframe
  (crossSiteMessage)="onReceiveMessage($event)"
  title="Navigation to {{ source }}"
  [src]="sanitizedSource"
  (load)="onLoad($event)"
></iframe>
